module.exports = __webpack_public_path__ + "img/Barbie.a738551e.png";